exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#addClientActionModal .multiselect__tags{padding-right:50px}#addClientActionModal .multiselect__content-wrapper .multiselect__element span{white-space:normal}", ""]);

// exports
